if(typeof AI == "undefined") {
	AI = {};
}

(function (AI) {
	'use strict';

	var shortlist = function() {
		this.shortlist = {};
	};

	shortlist.prototype = {

		init: function() {
			this.clickHandlers();
		},

		clickHandlers: function() {

			var self = this;
			jQuery(document).ready(function($) {
				$('.update-shortlist').click(function () {
					self.updateFromProperty(this);
					return false;
				});

				$('div.shortlist').click(function () {
					self.updateFromProperties(this);
					return false;
				});

				self.setShortlistCount();
			});

		},

		setShortlistCount: function() {

			// Get the shortlist
			var s = this.getCookie('shortlist');

			// If empty create it with the value of property id
			var count = 0;
			if (s === null) {
				this.createCookie('shortlist', '');
			} else {
				var ids = s.split('|');
				for (var i = 0; i<ids.length; i++ ) {
					if (parseInt(ids[i]) > 0) {
						count++;
					}
				}
			}
			var $el = jQuery('.shortlist_count');
			$el.html(count);
			if (count > 0) {
				$el.parent().addClass('with_shortlist_count');
			} else {
				$el.parent().removeClass('with_shortlist_count');
			}
		},

		createCookie: function(name,value,days) {
			var expires = "";
			if (days) {
				var date = new Date();
				date.setTime(date.getTime() + (days*24*60*60*1000));
				expires = "; expires=" + date.toUTCString();
			}
			document.cookie = name + "=" + value + expires + "; path=/";
		},

		getCookie: function (name) {
			var nameEQ = name + "=";
			var ca = document.cookie.split(';');
			for(var i=0;i < ca.length;i++) {
				var c = ca[i];
				while (c.charAt(0)==' ') c = c.substring(1,c.length);
				if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
			}
			return null;
		},

		updateFromProperty: function(div) {
			var status = this.updateShortlist(div);
			if (status == 'added') {
				this.updateHtml(div, 'Remove from shortlist');
			} else {
				this.updateHtml(div, 'Add to shortlist');
			}
		},

		updateFromProperties: function(div) {

			var status = this.updateShortlist(div);
			if (status == 'added') {
				this.updateHtml(div, '<a href="#" class="shortlist" title="Remove from your shortlist"><i class="fa fa-heart"></i><span>Shortlist</span></a>');
				jQuery(div).addClass('active');
			} else {
				this.updateHtml(div, '<a href="#" class="shortlist" title="Add to your short list"><i class="fa fa-heart-o"></i><span>Shortlist</span></a>');
				jQuery(div).removeClass('active');
			}

			if (jQuery(div).data("page") == 'shortlist') {
				window.location.reload();
			}
		},

		updateShortlist: function(div){

			var id = ""+jQuery(div).data("id")+"";

			// Get the shortlist
			var s = this.getCookie('shortlist');

			// If empty create it with the value of property id
			if (s === null) {
				this.alertMessage('Property shortlisted.');
				this.createCookie('shortlist', id);
				return 'added';
			}

			var ids = s.split('|');
			var index = ids.indexOf(id);
			if (index != -1) {
				ids.splice(index, 1);
				ids = ids.join('|');
				this.alertMessage('Property removed.');
				this.createCookie('shortlist', ids);
				this.setShortlistCount();
				return 'removed';
			} else {
				ids.push(id);
				ids = ids.join('|');
				this.alertMessage('Property shortlisted.');
				this.createCookie('shortlist', ids);
				this.setShortlistCount();
				return 'added';
			}
		},

		updateHtml: function(div, html) {
			jQuery(div).html(html);
		},

		alertMessage: function(message) {
			alertify.success(message);
		}
	};

	AI.shortlist = new shortlist();

})(AI);

AI.shortlist.init();


// WEBPACK FOOTER //
// ./resources/assets/js/ai/shortlists.js